import { Skeleton } from "@/components/ui/skeleton";

interface WebpageCardSkeletonProps {
  index: number;
}

export function WebpageCardSkeleton({ index }: WebpageCardSkeletonProps) {
  // Calculate opacity based on index (0.9 to 0.3)
  const opacity = Math.max(0.3, 0.9 - index * 0.15);

  return (
    <div 
      className="rounded-lg border border-white dark:border-neutral-800 bg-card text-card-foreground"
      style={{ opacity }}
    >
      <div className="p-6">
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-4 rounded" /> {/* favicon */}
          <Skeleton className="h-5 w-48" /> {/* title */}
        </div>
        <div className="mt-2">
          <Skeleton className="h-[2.5rem] w-full" /> {/* description with exact height */}
        </div>
        <div className="mt-4 flex items-center justify-between">
          <Skeleton className="h-4 w-32" /> {/* url */}
          <Skeleton className="h-4 w-24" /> {/* date */}
        </div>
      </div>
    </div>
  );
} 